import { IApiError } from '@/models/apiError.model';
import { IWebsites } from '@/models/websites.model';
import { IPaginationResponse } from '@/models/pagination.model';

export const SLICE_NAME = 'websites';

export interface WebsitesState {
  websites: IWebsites[] | null;
  pagination: IPaginationResponse | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: WebsitesState = {
  websites: null,
  pagination: null,
  isLoading: false,
  error: null,
};
